import React from "react";
import { motion } from "framer-motion";
import { hideAnimation, simpleContainer3 } from "../animate";
import { useScroll } from "./useScroll";
import useWindowDimensions from "./useDimension";

const CoursesDetail = (props) => {
  console.log(props);
  const { width } = useWindowDimensions();
  const [element, controls] = useScroll(width < 1000 ? 0 : 0.25);

  return (
    <div className="details">
      <motion.div
        className="desc"
        variants={simpleContainer3}
        initial="hidden"
        animate={controls}
        ref={element}
      >
        <h2>
          <span>
            這堂課適合誰? <br />
            我可以在這堂課獲得什麼?
          </span>
        </h2>
        <div style={{ overflow: "hidden" }}>
          <motion.h5 variants={hideAnimation}>
            <span style={{ textDecoration: "underline" }}>
              完成這堂課之後，你能:
            </span>
          </motion.h5>
        </div>
        <ol>
          <li>成為網頁全端工程師，自己接案開始工作，或是應徵科技業。</li>
          <li>使用資料庫，建構任何你喜歡的網站。</li>
          <li>
            深入了解HTML, CSS, JavaScript前端三大語言，寫出良好且優質的程式碼。
          </li>
          <li>不用花大錢，即可由簡入深學習到許多開發技巧和debug觀念!</li>
          <li>從頭開始架設屬於你自己的質感網頁!</li>
          <li>
            深入了解電腦科學與資訊工程的概念，包含排列演算法、資料加密、資料庫連接等等。
          </li>
        </ol>

        <div style={{ overflow: "hidden" }}>
          <motion.h5 variants={hideAnimation}>
            <span style={{ textDecoration: "underline" }}>這堂課是設計給:</span>
          </motion.h5>
        </div>
        <ol>
          <li>網頁開發有興趣的初學者</li>
          <li>大學資工系、資管系主修或副修學生</li>
          <li>曾經學過但是對於網頁前端排版了解不深入</li>
          <li>對於資訊科技有興趣，想要開始動手寫程式的人</li>
          <li>對於演算法與網路結構有興趣者</li>
          <li>想要轉換跑道、工作，成為網頁工程師的人</li>
          <li>想學習使用連結資料庫的網頁伺服器來建立網站者</li>
          <li>
            對於網頁前後端有基本概念與經驗，想要深入了解程式碼成為建站大師者。
          </li>
        </ol>
      </motion.div>
      <div className="images">
        <img src={props.img} alt="" />
      </div>
    </div>
  );
};

export default CoursesDetail;
